export const normalizeAttemptData = (data) => {
    if (!data?.pools?.$values) return [];

    return data.pools.$values.map(pool => ({
        poolId: pool.poolId,
        sequence: pool.sequence,
        pdf: pool.questionPdf,
        questions: pool.questions.$values.map(q => ({
            id: q.questionId,
            sequence: q.sequence,
            type: q.questionType === 1 ? "MCQ" : q.questionType === 2 ? "SCQ" : q.questionType === 3 ? "TrueFalse" : "Numerical",

            options: [
                q.questionChoice?.choiceId01,
                q.questionChoice?.choiceId02,
                q.questionChoice?.choiceId03,
                q.questionChoice?.choiceId04,
                q.questionChoice?.choiceId05,
                q.questionChoice?.choiceId06,
            ].filter(Boolean),

            // ✅ KEEP FULL OBJECT
            questionChoice: q.questionChoice,

            // ✅ user selected answer
            response: q.questionChoice?.choiceIdAnswers || null,
        }))
    }));
};